<template>
  <div class="slideout charging-slideout" :class="{ 'slideout--show' : slideoutVisible }">
    <div v-if="slideoutVisible">
      <!-- Header -->
      <div class="row">
        <div class="col-10 text-left">
          <div>
            <h3><span>Pence Per Mile Efficiency</span></h3>
            <p class="slideout-subtitle">Amend the percentage split of where you estimate you will charge your
              electric vehicle, remember to ensure the percentages add up to 100%!</p>
            <ul>
              <li>
                <span class="label">Home Charging (Standard) @ {{ adminPortalData.content.global.ev_charging_home }}p per kWh</span>
                <span class="input-has-percentage-symbol">
                    <input type="number" v-model="homeChargingStandardPercentage" step="5" min="0" max="100">
                  </span>
              </li>
              <li>
                  <span class="label">Public Charging (Standard) @ {{
                      adminPortalData.content.global.ev_charging_public_standard
                    }}p per kWh</span>
                <span class="input-has-percentage-symbol">
                    <input type="number" v-model="publicChargingStandardPercentage" step="5" min="0" max="100">
                  </span>
              </li>
              <li>
                  <span class="label">Public Charging (Fast Charge) @ {{
                      adminPortalData.content.global.ev_charging_public_fast
                    }}p per kWh</span>
                <span class="input-has-percentage-symbol">
                    <input type="number" v-model="publicChargingFastPercentage" step="5" min="0" max="100">
                  </span>
              </li>
              <li>
                  <span class="label">Public Charging (Free) @ {{
                      adminPortalData.content.global.ev_charging_public_free
                    }}p per kWh</span>
                <span class="input-has-percentage-symbol">
                    <input type="number" v-model="publicChargingFreePercentage" step="5" min="0" max="100">
                  </span>
              </li>
            </ul>
            <button class="button button--steelBlue mt-4" @click="saveChargingProfile">Save</button>
          </div>
        </div>
        <div class="col-2 text-right">
          <button @click="hideSlideout" class="close"><i class="icon-cross"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from "../event-bus";

export default {
  props: [
    'adminPortalData',
    'slideoutVisibleOverride'
  ],

  data: () => {
    return {
      slideoutVisible: false,
      homeChargingStandardPercentage: 25,
      publicChargingStandardPercentage: 25,
      publicChargingFastPercentage: 25,
      publicChargingFreePercentage: 25,
    }
  },

  mounted() {
    this.getChargingProfile();
    EventBus.$on('charging-slideout-visible', (status) => {
      this.slideoutVisible = true;
    });
  },

  watch: {
    slideoutVisibleOverride: function (state) {
      this.slideoutVisible = state;
    }
  },

  methods: {
    getChargingProfile() {
      this.$http.get('/api/get-charging-profile')
        .then(response => {
          this.homeChargingStandardPercentage = response.data.data.home_charging_standard_percentage;
          this.publicChargingStandardPercentage = response.data.data.public_charging_standard_percentage;
          this.publicChargingFastPercentage = response.data.data.public_charging_fast_percentage;
          this.publicChargingFreePercentage = response.data.data.public_charging_free_percentage;
        })
        .catch(err => {
          console.log(err);
          EventBus.$emit('loading', false);
          let response = err.response;

          Vue.notify({
            group: 'notify',
            type: 'error',
            title: "Error",
            text: response.data.message
          });

          this.error = err.message.toString();
          this.$router.push({name: response.data.redirect, params: {...this.$route.params}});
        })
        .finally(() => {
          EventBus.$emit('loading', false);
        });;
    },

    saveChargingProfile() {
      const total = parseInt(this.homeChargingStandardPercentage) + parseInt(this.publicChargingStandardPercentage) + parseInt(this.publicChargingFastPercentage) + parseInt(this.publicChargingFreePercentage);

      if (total !== 100) {
        Vue.notify({
          group: 'notify',
          type: 'error',
          title: "Error",
          text: "Please ensure all percentages add up to 100% before saving (current total is " + total + "%)",
        });
        return;
      }

      if (parseInt(this.homeChargingStandardPercentage) < 0 || parseInt(this.publicChargingStandardPercentage) < 0 || parseInt(this.publicChargingFastPercentage) < 0 || parseInt(this.publicChargingFreePercentage) < 0) {
        Vue.notify({
          group: 'notify',
          type: 'error',
          title: "Error",
          text: "Percentages cannot be negative",
        });
        return;
      }

      EventBus.$emit('loadingTitle', 'Saving Charging Profile');
      EventBus.$emit('loading', true);

      const newChargingProfile = {
        homeChargingStandardPercentage: this.homeChargingStandardPercentage,
        publicChargingStandardPercentage: this.publicChargingStandardPercentage,
        publicChargingFastPercentage: this.publicChargingFastPercentage,
        publicChargingFreePercentage: this.publicChargingFreePercentage,
      }

      this.$http.post('/api/save-charging-profile', newChargingProfile)
        .then(response => {
          EventBus.$emit('loading', false);
          EventBus.$emit('charging-profile-updated', newChargingProfile);

          Vue.notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: 'Charging Profile saved successfully'
          });

          this.hideSlideout();
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response;

          Vue.notify({
            group: 'notify',
            type: 'error',
            title: "Error",
            text: response.data.error.message
          });

        });
    },

    hideSlideout() {
      EventBus.$emit('charging-slideout-hidden', true);
      this.slideoutVisible = false;
    },
  }
}
</script>

<style scoped>

</style>
